module.exports = () => {
    // Body class to manipulate all-in-let-op-banner position 
    if ($('.all-in-let-op-banner').length > 0) {
        $('body').addClass('has-all-in-let-op-banner');
    }
};
